<template>
  <div class="container mt-4">
    <b-card>
      <b-card-group deck>
        <b-card header="UGs a serem adicionadas">
          <SeletorDeUGs
            :ugsSelecionadas="this.ugSelecionadas"
            @AtualizarListaDel="atualizarListaUGsSelecionadas"
            @AtualizarListaAdd="atualizarListaUGsSelecionadas"
          />
          <b-button
            variant="success"
            size="sm"
            @click="adicionarGestor"
            :disabled="ugSelecionadas.length === 0"
            >Adicionar</b-button
          >
        </b-card>
        <b-card header="UGs geridas por este usuário">
          <b-table
            striped
            hover
            stacked="md"
            :items="ugsGeridasComp"
            :fields="computedFields"
            class="no-header-lines"
          >
            <template slot="cell(actions)" slot-scope="UGData">
              <b-button size="sm" @click="alertaGestorRemove(UGData.item)">
                <font-awesome-icon icon="trash" />
              </b-button>
            </template>
            <template slot="cell(Nome)" slot-scope="UgData">
              <div>
                <b>{{ UgData.item.Nome }}</b>
              </div>
              <div>
                <small
                  ><i>{{ UgData.item.gestorUG.nome }}</i></small
                >
              </div>
            </template>
          </b-table>
        </b-card>
      </b-card-group>
    </b-card>
  </div>
</template>

<script lang="ts">
import { mixins } from "vue-class-component";
import { UtilsTS } from "@/utilsts";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Usuario } from "@/types/administracao/usuarios/usuario";
import { PropType } from "vue";
import SeletorDeUGs from "./SeletoDeUGs.vue";
import { store } from "@/store";
import { UnidadeGestoraResumida } from "@/types/ug/unidade-gestora-resumida";
import ugService from "@/services/administracao/ugService";
import { TableField } from "@/types/table-field";

const CompProps = Vue.extend({
  name: "AbaEditarGestorPorUG",
  components: { SeletorDeUGs },
  props: {
    usuario: {
      type: Object as PropType<Usuario>,
      required: false,
    },
  },
});

@Component
export default class AbaEditarGestorPorUG extends mixins(UtilsTS, CompProps) {
  ugSelecionadas: UnidadeGestoraResumida[] = [];
  ugsGeridasComp: UnidadeGestoraResumida[] = [];
  ugsGeridas: UnidadeGestoraResumida[] = [];
  UGs: UnidadeGestoraResumida = new UnidadeGestoraResumida();

  mounted() {
    //console.log(this.usuario);
    this.carregarUGsGeridas();
  }

  get computedFields(): TableField[] {
    const fields: TableField[] = [
      { key: "Nome", label: "", tdClass: "quebrarPorPalavraHard" },
    ];
    if (this.ugsGeridas.length > 0) {
      fields.push({ key: "actions", label: "", tdClass: "" });
    }
    return fields;
  }

  async carregarUGsGeridas() {
    this.ugsGeridas = [];
    this.ugsGeridasComp = [];
    try {
      store.blockScreen = true;
      const response = await ugService.ListarUGsGeridas(this.usuario.CPF);
      this.ugsGeridas = response;
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      store.blockScreen = false;
      //console.log(this.ugsGeridas)
    }

    this.ugsGeridas.map((ug) => {
      this.chamarUGCompleta(ug);
    });

    //console.log(this.ugsGeridasComp);
  }

  async chamarUGCompleta(ug: UnidadeGestoraResumida) {
    try {
      store.blockScreen = true;
      const response = await ugService.obterUGgestor(String(ug.Codigo));
      this.ugsGeridasComp.push(response);
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      store.blockScreen = false;
      //console.log(this.ugsGeridasComp)
    }
  }
  atualizarListaUGsSelecionadas(novaLista: UnidadeGestoraResumida[]) {
    this.ugSelecionadas = [];
    this.ugSelecionadas = novaLista;
  }

  async adicionarGestor() {
    try {
      store.blockScreen = true;
      //Faz a requisição em todas as ugs selecionadas
      const responses = this.ugSelecionadas.map((item) => {
        return ugService.cadastrarGestor(
          Number(item.idCRP),
          this.usuario.ID_USUARIO
        );
      });
      await Promise.all(responses);
      //Após a requisição acabar chama a função para atualizar o componente da lista
      this.carregarUGsGeridas();

      this.ugSelecionadas = [];
      this.$toast.success("Gestor(a) adicionado(a) com sucesso!");
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      store.blockScreen = false;
      //console.log(this.ugsGeridasComp);
    }
  }

  async removerGestor(idUG: string) {
    try {
      store.blockScreen = true;
      const response = await ugService.excluirGestor(Number(idUG));
      this.ugsGeridasComp = this.ugsGeridasComp.filter(
        (item) => item.idCRP !== idUG
      );
      this.$toast.success("Gestor(a) removido(a) com sucesso!");
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      store.blockScreen = false;
    }
  }

  //Atualiza componente após o gestor ser adicionado a uma UG

  //Confirmação para exxcluir um perfil
  alertaGestorRemove(UG: UnidadeGestoraResumida): any {
    this.$bvModal
      .msgBoxConfirm(
        `Deseja remover ${this.usuario.NOME} da gestão da UG ${this.capitalize(
          UG.Nome
        )} ?`,
        {
          buttonSize: "sm",
          cancelTitle: "Cancelar",
          cancelVariant: "outline-secondary",
          centered: true,
          headerBgVariant: "secondary",
          headerTextVariant: "light",
          okTitle: "Confirmar",
          title: "Remover Gestor(a)",
        }
      )
      .then((value) => {
        if (value) {
          if (UG.idCRP) {
            this.removerGestor(UG.idCRP);
          }
        }
      })
      .catch((err) => {
        console.error(
          `Erro ao operar o dialog de alerta de remoção de perfil`,
          err
        );
      });
  }
}
</script>

<style scoped>
::v-deep .no-header-lines thead {
  display: none;
}
</style>
